const RegistrationType = {
  SET_REG_LIST: "SET_REG_LIST",
  SET_SELLER_PROFILE: "SET_SELLER_PROFILE",
  SET_REFERRAL_LIST: "SET_REFERRAL_LIST",
  BS_LIST: "BS_LIST",
  SET_BS_REQUESTR_LIST: "SET_BS_REQUESTR_LIST",
  BS_SEND_REQUEST: "BS_SEND_REQUEST",
  SET_BUYER_REQUESTR_LIST: "SET_BUYER_REQUESTR_LIST",
  BS_REQUEST_ACCEPT_REJECT: "BS_REQUEST_ACCEPT_REJECT",
  MY_BUYER_LISTY: "MY_BUYER_LISTY",
};

export interface GetRegistration {
  limit: number;
  offset: number;
  keyword: string;
  sortBy: string;
  sortType: string;
  search: any;
}

export interface GetSellerProfile {
  id: number;
}

export interface GetReferralList {
  limit: number;
  offset: number;
  page: number;
  keyword: string;
  sortBy: string;
  sortType: string;
  search: any;
}

export interface GetBSList {
  userType: string;
}

export interface GetBSRequestList {
  limit: number;
  offset: number;
  page: number;
  keyword: string;
  sortBy: string;
  sortType: string;
  search: any;
}

export interface BSSendRequest {
  id: any;
  status: string;
}

export interface GetBuyerRequestList {
  limit: number;
  offset: number;
  page: number;
  keyword: string;
  sortBy: string;
  sortType: string;
  search: any;
}

export interface RequestAcceptReject {
  id: number;
  status: string;
}

export interface CreateBuyer {
  name_of_entity: string;
  email: string;
  mobile: number;
  password: string;
}

export interface GetMyBuyerList {
  search: any;
  limit: number;
}

export default RegistrationType;
